import type { MarginModifierValue } from "schemas/generated/fileModifiers";

import React from "react";

import SpacingModifier from "./SpacingModifier";

interface MarginModifierProps {
  onChange: (modifiers: MarginModifierValue[]) => void;
}

const MarginModifierComponent: React.FC<MarginModifierProps> = ({
  onChange,
}) => {
  return (
    <SpacingModifier
      onChange={onChange}
      config={{
        type: "margin",
        unifiedTooltipText: "Use unified margin",
        individualTooltipText: "Set individual margins",
      }}
    />
  );
};

export default MarginModifierComponent;
